import { COMPANY } from './company'
import { ROUTES } from './routes'

export const CONTACT_PAGE = {
  eyebrow: 'Get in touch',
  title: 'Contact Maaliondoor',
  lead: 'Reach our team for orders, corporate gifting, decoration projects, or partnership enquiries.',
  channels: [
    {
      label: 'Customer support',
      value: COMPANY.phoneDisplay,
      href: COMPANY.phoneHref,
    },
    {
      label: 'Email',
      value: COMPANY.email,
      href: COMPANY.emailHref,
    },
    {
      label: 'Website',
      value: COMPANY.websiteLabel,
      href: COMPANY.websiteHref,
    },
  ],
  officeTitle: 'Registered office',
  officeAddress: COMPANY.address,
  companyName: COMPANY.legalName,
  gstinLabel: 'GSTIN',
  gstin: COMPANY.gstin,
  linksTitle: 'Quick links',
  links: [
    { label: 'Corporate gifting enquiry', to: ROUTES.corporateEnquiry },
    { label: 'Become a vendor', to: ROUTES.vendorRegistration },
    { label: 'FAQs', to: ROUTES.faqs },
    { label: 'Available locations', to: ROUTES.locations },
  ],
} as const
